import React, { useMemo } from 'react';
import { DateUtils } from '@vectord/utils';
import { Accordion, Icon } from '@vectord/components';
import orderBy from 'lodash/orderBy';

import ScheduledClassesTable from '../ScheduledClassesTable';
import styles from './CompletedClassesAccordion.module.scss';

export default function CompletedClassesAccordion({ sbatGroups }) {
  const completedSbatGroups = useMemo(
    () =>
      orderBy(
        sbatGroups.filter(
          (sbatGroup) =>
            new Date(sbatGroup.date_of_topic) < Date.now() - DateUtils.ONE_HOUR
        ),
        (o) => new Date(o.date_of_topic),
        'desc'
      ),
    [sbatGroups]
  );

  if (completedSbatGroups.length > 0) {
    return (
      <Accordion
        className="m-t-m cursor"
        title={({ active, onClick }) => (
          <div
            onClick={onClick}
            role="presentation"
            className="m-b-xxs"
          >
            <div className="row align-c dark bold">
              <div className=" m-r-xxs">Completed Classes</div>
              <Icon name={active ? 'chevron-up' : 'chevron-down'} />
            </div>
            <div className="hint h6">
              You can not prepone, postpone or delete classes after they are
              completed.
            </div>
          </div>
        )}
      >
        <div className={styles.body}>
          <ScheduledClassesTable sbatGroups={completedSbatGroups} />
        </div>
      </Accordion>
    );
  } else {
    return null;
  }
}
